import { Box, Grid } from "@mui/material"
import { IPhoneCard } from "./IPhoneCard"

const PhoneCard = ({ cardContent }: IPhoneCard) => {
    return (
        <Box sx={{
            borderRadius: '8px',
            border: '1px solid var(--border-color)', background: "var(--input-bg-color)", padding: "0px 20px"
        }}>
            {cardContent.map((item, index) => (
                <Grid container key={index} sx={{ paddingY: "1rem", width: '100%', alignItems: "center", justifyContent: "space-between", borderBottom: index === cardContent.length - 1 ? "none" : "2px solid var(--hr-color)" }}>
                    <Grid item className="text-[var(--tirnary-text-color)]" sx={{ fontWeight: "bold" }}>{item.title}</Grid>
                    <Grid item className="text-[var(--tirnary-text-color)]">{item.value}</Grid>
                </Grid>
            ))}
        </Box>
    )
}

export default PhoneCard
